import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

import {
	coreDataSecurityDetectedApplicationsActiveTokensReducers,
	coreDataSecurityDetectedApplicationsActiveTokensWatchers
} from './tokens';
import {
	coreDataSecurityDetectedApplicationsByIdReducers,
	coreDataSecurityDetectedApplicationsByIdWatchers
} from './_id';

export const coreDataSecurityDetectedApplicationsReducers = combineReducers({
	byId: coreDataSecurityDetectedApplicationsByIdReducers,
	tokens: coreDataSecurityDetectedApplicationsActiveTokensReducers
});

export const coreDataSecurityDetectedApplicationsWatchers = combineAllWatchers([
	coreDataSecurityDetectedApplicationsByIdWatchers,
	coreDataSecurityDetectedApplicationsActiveTokensWatchers
]);
